var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSketch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 96 86"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FDB300",
    d: "M20.903 2.831l27-2.831 27 2.831 20.903 27.835L47.903 86 0 30.666z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EA6C00",
    d: "M19.403 30.666L47.903 86 0 30.666zM76.403 30.666L47.903 86l47.903-55.334z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FDAD00",
    d: "M19.403 30.666h57L47.903 86z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FDD231",
    d: "M47.903 0l-27 2.831-1.5 27.835zM47.904 0l27 2.831 1.5 27.835z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FDAD00",
    d: "M95.806 30.666L74.903 2.831l1.5 27.835zM0 30.666L20.903 2.831l-1.5 27.835z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FEEEB7",
    d: "M47.903 0l-28.5 30.666h57z"
  }))));
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA5NiA4NiI+CiAgPGcgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj4KICAgIDxwb2x5Z29uIGZpbGw9IiNGREIzMDAiIHBvaW50cz0iMjAuOTAzIDIuODMxIDQ3LjkwMyAwIDc0LjkwMyAyLjgzMSA5NS44MDYgMzAuNjY2IDQ3LjkwMyA4NiAwIDMwLjY2NiIvPgogICAgPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMCAzMC42NjYpIj4KICAgICAgPHBvbHlnb24gZmlsbD0iI0VBNkMwMCIgcG9pbnRzPSIxOS40MDMgMCA0Ny45MDMgNTUuMzM0IDAgMCIvPgogICAgICA8cG9seWdvbiBmaWxsPSIjRUE2QzAwIiBwb2ludHM9IjY3LjMwNyAwIDk1LjgwNyA1NS4zMzQgNDcuOTA0IDAiIHRyYW5zZm9ybT0ibWF0cml4KC0xIDAgMCAxIDE0My43MSAwKSIvPgogICAgICA8cG9seWdvbiBmaWxsPSIjRkRBRDAwIiBwb2ludHM9IjE5LjQwMyAwIDc2LjQwMyAwIDQ3LjkwMyA1NS4zMzQiLz4KICAgIDwvZz4KICAgIDxwb2x5Z29uIGZpbGw9IiNGREQyMzEiIHBvaW50cz0iNDcuOTAzIDAgMjAuOTAzIDIuODMxIDE5LjQwMyAzMC42NjYiLz4KICAgIDxwb2x5Z29uIGZpbGw9IiNGREQyMzEiIHBvaW50cz0iNzYuNDAzIDAgNDkuNDAzIDIuODMxIDQ3LjkwMyAzMC42NjYiIHRyYW5zZm9ybT0ibWF0cml4KC0xIDAgMCAxIDEyNC4zMDcgMCkiLz4KICAgIDxwb2x5Z29uIGZpbGw9IiNGREFEMDAiIHBvaW50cz0iNzQuOTA0IDMwLjY2NiA5NS44MDcgMi44MzEgOTQuMzA3IDMwLjY2NiIgdHJhbnNmb3JtPSJtYXRyaXgoLTEgMCAwIDEgMTcwLjcxIDApIi8+CiAgICA8cG9seWdvbiBmaWxsPSIjRkRBRDAwIiBwb2ludHM9IjAgMzAuNjY2IDIwLjkwMyAyLjgzMSAxOS40MDMgMzAuNjY2Ii8+CiAgICA8cG9seWdvbiBmaWxsPSIjRkVFRUI3IiBwb2ludHM9IjQ3LjkwMyAwIDE5LjQwMyAzMC42NjYgNzYuNDAzIDMwLjY2NiIvPgogIDwvZz4KPC9zdmc+Cg==";
export { SvgSketch as ReactComponent };